import { z } from 'zod';

import { fixture } from './fixtures';

export enum GroupType {
	And = 'AND',
	Or = 'OR',
}

export const Condition = z.object({
	attr: z.string(),
	value: z.string(),
});

export type Condition = z.infer<typeof Condition>;

export const RuleGroup = z.object({
	id: z.string(),
	groupType: z.enum(GroupType),
	conditions: z.array(Condition),
});

export type RuleGroup = z.infer<typeof RuleGroup>;

// Fixture functions using manual generators
export const conditionFixture = (overrides: Partial<Condition> = {}): Condition => ({
	attr: fixture.string('attr'),
	value: fixture.string('value'),
	...overrides,
});

export const ruleGroupFixture = (overrides: Partial<RuleGroup> = {}): RuleGroup => ({
	id: fixture.id(),
	groupType: GroupType.And,
	conditions: [conditionFixture()],
	...overrides,
});
